import { Link } from "react-router-dom";
import type { Movie } from "@/lib/types";
import { formatDate, formatViews } from "@/lib/movies";

interface DetailSidebarProps {
  movie: Movie;
}

export default function DetailSidebar({ movie }: DetailSidebarProps) {
  const rows = [
    { label: "评分", value: `${movie.rating.toFixed(1)} / 10` },
    { label: "篇幅", value: movie.duration },
    { label: "语言", value: movie.language },
    { label: "收录", value: formatDate(movie.addedAt) },
    { label: "更新", value: formatDate(movie.updatedAt) },
    { label: "阅读", value: formatViews(movie.views) },
  ];

  return (
    <aside className="flex flex-col gap-5 lg:sticky lg:top-24">
      <section className="rounded-lg border border-background-200/70 bg-background-100/60 p-4 md:p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading text-base font-semibold text-foreground-50">作品资料</h2>
          <i className="ri-information-line text-foreground-600"></i>
        </div>
        <dl className="flex flex-col gap-2.5">
          {rows.map((row) => (
            <div key={row.label} className="flex items-center justify-between gap-3 text-xs">
              <dt className="text-foreground-600">{row.label}</dt>
              <dd className="text-foreground-300 text-right">{row.value}</dd>
            </div>
          ))}
        </dl>
        <div className="mt-5 pt-4 border-t border-background-200/60">
          <p className="text-[11px] text-foreground-600 mb-2">题材标签</p>
          <div className="flex flex-wrap gap-1.5">
            {movie.genres.map((genre) => (
              <Link
                key={genre}
                to={`/category?genre=${encodeURIComponent(genre)}`}
                className="px-2 py-1 rounded bg-background-200/70 text-[11px] text-foreground-300 hover:bg-primary-500 hover:text-foreground-50 transition-colors cursor-pointer"
              >
                {genre}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="rounded-lg border border-secondary-200/50 bg-secondary-100/60 p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2.5">
          <i className="ri-lightbulb-flash-line text-accent-500"></i>
          <h2 className="font-heading text-base font-semibold text-foreground-50">阅读提示</h2>
        </div>
        <p className="text-xs leading-relaxed text-foreground-400">
          本站内容包含完整剧情走向与结局讨论，建议在观看后阅读。所有文字均为编辑撰写，站内不提供播放与下载入口。
        </p>
      </section>

      <Link
        to="/category"
        className="h-11 rounded-md border border-background-300 text-foreground-200 text-sm inline-flex items-center justify-center gap-2 hover:border-accent-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-line"></i>
        返回影视分类
      </Link>
    </aside>
  );
}